import { setCartDiscountType } from '../../../action/cartDiscount'
import { localStorageApi } from '../../../../helper/localStorageApi'

export const setCartDiscountTypeWithStorageThunk = (discountType) => dispatch => {
	dispatch(setCartDiscountType(discountType))
	localStorageApi.setItem('discount', discountType)
}
